var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 94,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m27.3 63.426-1.833 13.342M41.233 63.426l1.375 10.462M42.608 73.888a8.4 8.4 0 0 1 1.192-.085c4.356 0 7.938 3.34 8.386 7.62M42.608 73.888c-4.092.585-7.241 4.14-7.241 8.439M52.186 81.423a10.9 10.9 0 0 1 4.447-.95c6.076 0 11.367 5.72 11.367 11.86M16.791 81.653c.664-3.829 3.968-6.738 7.942-6.738M16.791 81.653a11 11 0 0 0-3.058-.438C7.658 81.215 2 86.193 2 92.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M34.267 1.905c-5.867 0-16.134 16.444-16.134 32.614 0 11.203 2.934 21.866 8.067 28.166h8.067M34.267 1.905c5.866 0 16.133 16.444 16.133 32.614 0 11.203-2.933 21.866-8.067 28.166h-8.066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M27.564 24.26a9.02 9.02 0 0 0-2.094 6.015c.11 4.91 4.06 8.802 8.819 8.691s8.528-4.18 8.415-9.091c-.11-4.91-4.06-8.802-8.819-8.69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M45.267 56.385h-16.5M19.233 46.378l-3.289 2.313c-3.223 2.264-5.144 5.981-5.144 9.95v6.638l8.8-5.188M49.3 46.378l3.29 2.313c3.222 2.264 5.143 5.981 5.143 9.95v6.638l-8.8-5.188"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M16.791 81.652q-.122.689-.124 1.416a8.15 8.15 0 0 0 1.873 5.215"
  })));
};
export default SvgRocket;